import { render, staticRenderFns } from "./NotifPermission.vue?vue&type=template&id=4e626644&"
import script from "./NotifPermission.vue?vue&type=script&lang=js&"
export * from "./NotifPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports